import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { loadAbilities, pathToPermissionKey } from '../utils/permissions';
import { useAuth } from '../contexts/AuthContext';

const RequirePermission = ({ pathKey, requireAdmin, children }) => {
  const location = useLocation();
  const { user } = useAuth();
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (requireAdmin) {
        const isAdmin = user?.role === 'admin';
        if (mounted) setAllowed(!!isAdmin);
        return;
      }
      const abilities = await loadAbilities();
      const key = pathKey || pathToPermissionKey(location.pathname);
      const ok = !!abilities[key];
      if (mounted) setAllowed(ok);
    })();
    return () => { mounted = false; };
  }, [location.pathname, pathKey, requireAdmin, user?.role]);

  if (allowed === null) return null; // let parent loader show
  if (!allowed) return <Navigate to="/" replace />;
  return children;
};

export default RequirePermission;



